if (!customElements.get('bnpl-info-drawer')) {
  customElements.define(
    'bnpl-info-drawer',
    class BnplInfoDrawer extends HTMLElement {
      constructor() {
        super()

        this.onBodyClick = this.handleBodyClick.bind(this)
        this.onTriggerClick = this.handleTriggerClick.bind(this)

        // Overlay is a sibling element in the markup, not a child —
        // grab a reference to it here so show()/hide() can toggle it
        this.overlay = this.previousElementSibling?.classList.contains('bnpl-info-drawer__overlay')
          ? this.previousElementSibling
          : document.querySelector('.bnpl-info-drawer__overlay')

        this.overlay?.addEventListener('click', () => {
          this.hide()
        })

        this.querySelector('.bnpl-info-drawer__close')?.addEventListener(
          'click',
          () => {
            this.hide()
          }
        )

        this.addEventListener('keyup', (event) => {
          if (event.code?.toUpperCase() === 'ESCAPE') {
            this.hide()
          }
        })
      }

      connectedCallback() {
        document.addEventListener('click', this.onTriggerClick)

        this.querySelectorAll('.bnpl-tab').forEach((tab) => {
          tab.addEventListener('click', () => {
            const target = tab.dataset.bnplTab

            this.querySelectorAll('.bnpl-tab').forEach((button) => {
              button.classList.remove('is-active')
            })

            this.querySelectorAll('.bnpl-panel').forEach((panel) => {
              panel.classList.remove('is-active')
            })

            tab.classList.add('is-active')

            this.querySelector(
              `[data-bnpl-panel="${target}"]`
            )?.classList.add('is-active')
          })
        })

        // Initialize first tab
        const firstTab = this.querySelector('.bnpl-tab')

        if (firstTab && !this.querySelector('.bnpl-tab.is-active')) {
          firstTab.click()
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onTriggerClick)
      }

      handleTriggerClick(event) {
        const trigger = event.target.closest('.bnpl-info-trigger')

        if (!trigger) return

        this.show()
      }

      handleBodyClick(evt) {
        const target = evt.target

        if (
          target !== this &&
          !target.closest('bnpl-info-drawer') &&
          !target.closest('.bnpl-info-trigger')
        ) {
          this.hide()
        }
      }

      hide() {
        this.removeAttribute('open')
        this.overlay?.classList.remove('is-visible')
        document.body.removeEventListener('click', this.onBodyClick)
        document.body.classList.remove('overflow-hidden')
      }

      show() {
        this.setAttribute('open', '')
        this.overlay?.classList.add('is-visible')
        document.body.addEventListener('click', this.onBodyClick)
        document.body.classList.add('overflow-hidden')
      }
    }
  )
}